import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ProfileAndPeerComparison from './ProfileAndPeerComparison';
import { getPeerAndProfileGraph } from '../../../../redux/actions/tmCommon';
import {
  getTypologyList,
  getRiskIndicatorListByTypologyId
} from '../../../../redux/actions/tmCommon';

function mapStateToProps(state) {
  return {
    settings: state.settings,
    peerProfileGraph: state.amlsTMCommon.peerProfileGraph,
    typologyList: state?.amlsTMCommon?.typologyList?.data,
    riskIndicatorList: state?.amlsTMCommon?.riskIndicatorList?.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        getPeerAndProfileGraph,
        getTypologyList,
        getRiskIndicatorListByTypologyId
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileAndPeerComparison);
